import * as React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { localizations } from '../../localization/localization';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { RestrictedCompanyModel } from '../../common/models/CommonModels';
import * as companyApi from '../../api/companyApi'

type SubmitType = (selected: string[]) => void;
type CancelType = () => void;

interface RestrictedProps {
    restricted: string[];
}

type DialogProps = DialogPropsBase<SubmitType, CancelType> & RestrictedProps;

interface AddDialogState {
    candidates: RestrictedCompanyModel[];
    selected: string[];
    original: string[];
}

class AddRestrictionDialog extends React.Component<DialogProps, AddDialogState>  {
    constructor(props: DialogProps) {
        super(props);

        this.state = {
            candidates: [],
            selected: [],
            original: []
        }

        this.handleCheck = this.handleCheck.bind(this);
    }

    public componentDidMount() {
        companyApi.getRestrictedCompanies("").then(restricted => {
            companyApi.getRestrictionCandidates().then(data => {
                this.setState({
                    candidates: data,
                    selected: restricted.map(item => item.restrictedCompanyId),
                    original: restricted.map(item => item.restrictedCompanyId),
                });
            });
        });
    }

    public render() {

        const { isOpen, onCancel, onSubmit } = this.props;

        return (
            <Dialog open={isOpen}>
                <DialogTitle>{localizations.settings.addVisibilityRestriction}</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                    {localizations.forms.addRestriction}
                    </Typography>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{localizations.actions.selected}</TableCell>
                                <TableCell>{localizations.common.companyName}</TableCell>
                                <TableCell>{localizations.common.businessId}</TableCell>
                                <TableCell>{localizations.common.city}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.candidates.map((item, index) =>
                                <TableRow key={index}>
                                    <TableCell><Checkbox onChange={this.handleCheck(item.id)} disabled={this.state.original.indexOf(item.id) > -1} checked={this.state.selected.indexOf(item.id) > -1} /></TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{item.businessId}</TableCell>
                                    <TableCell>{item.city}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onCancel()}>{localizations.actions.cancel}</Button>
                    <Button onClick={() => onSubmit(this.state.selected)}>{localizations.actions.add}</Button>
                </DialogActions>
            </Dialog>
        );
    }

    private handleCheck = (id: string) => (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        const ids = this.state.selected;
        const index = ids.indexOf(id)
        if (checked && index < 0) {
            ids.push(id);
        }
        else {
            ids.splice(index, 1);
        }

        this.setState({
            selected: ids
        });
    }
}

export default AddRestrictionDialog;


// WEBPACK FOOTER //
// ./src/account/forms/AddRestrictionDialog.tsx